import React, { useEffect, useState } from 'react';
import { CONFIGURATION_KEYS } from '../../../helpers/constants';
import { getConfiguration } from '../../../helpers/utils';
import Toast from '../../toast/toast';
import { useTranslations } from './use-translations';

export const useCertificatesToast = () => {
    const [showToast, setShowToast] = useState(false);
    const [maxCertificates, setMaxCertificates] = useState(200);
    const { tooManyCertificates } = useTranslations();
    const renderedToast = (
        <Toast
            showToast={showToast}
            message={`${tooManyCertificates} ${maxCertificates}`}
            onClose={() => setShowToast(false)}
        />
    );

    useEffect(() => {
        const fetchConfiguration = async () => {
            const maxCertificatesCanDownload =
                (await getConfiguration(
                    CONFIGURATION_KEYS.MAX_CERTIFICATES_CAN_DOWNLOAD
                )) || 200;
            setMaxCertificates(maxCertificatesCanDownload);
        };

        fetchConfiguration();
    }, []);

    return {
        renderedToast,
        onOpenToast: () => {
            setShowToast(false);
            setShowToast(true);
        }
    };
};



// WEBPACK FOOTER //
// ./components/certificates/hooks/use-certificates-toast.js